<template>
  <div>
    <div class="search flex">
      <span class="tit">地区医院/组织管理</span>
      <div class="flex">
        <el-button @click="toEdit(0)" size="mini" class="addBtn">添加</el-button>
        <el-input
            suffix-icon="el-icon-search"
            class="addART"
            v-model="search"
            size="mini"
            placeholder="输入关键字搜索"/>
      </div>
    </div>
    <div class="instrument">
      <el-table
          :data="itemList.filter(data => !search || data.title.toLowerCase().includes(search.toLowerCase()))"
          class="record-table"
          :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
          height="calc(100vh - 265px)"
          row-key="id"
          max-height="calc(100vh - 265px)">
        <el-table-column
            prop="title"
            label="标题"
            width="180" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            prop="subTitle"
            label="副标题"
            width="180" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            width="120" align="center"
            prop="type"
            label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1" style="color: #409EFF">医院</span>
            <span v-if="scope.row.type === 2" style="color: #56C147">社区组织</span>
            <span v-if="scope.row.type === 3" style="color: #E6A23C">其他</span>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="status"
            label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1" @click="changeStatus(scope.row)" class="green common">启用</span>
            <span v-else-if="scope.row.status === 0" @click="changeStatus(scope.row)" class="pink common">封禁</span>
            <span v-else @click="changeStatus(scope.row)" class="pink common">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center">
          <template slot="header">
            <el-button @click="submitSort">排序</el-button>
          </template>
        </el-table-column>
        <el-table-column
            prop="remark"
            label="备注" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            align="right"
            width="200" label="操作">
          <template slot-scope="scope">
            <el-popconfirm
                @confirm="del(scope.row.id)"
                title="确定删除吗？">
              <el-button slot="reference"
                         size="mini"
                         type="text"
                         class="btn">删除</el-button>
            </el-popconfirm>
            <el-button @click="toEdit(scope.row)" size="mini" type="text" class="btn">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-drawer
        :visible.sync="editDialog.visible"
        :wrapper-closable="false"
        :show-close="false"
        :title="(editDialog.mode==='add'?'新增':'编辑')+'子项'"
        size="700px" class="drawerCommon">
      <el-form :model="curItem" ref="form" :rules="rules" label-suffix="：" label-width="90px" class="maxHeight">
        <el-form-item label="标题" prop="title">
          <el-input v-model="curItem.title"  placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="副标题" prop="subTitle">
          <el-input v-model="curItem.subTitle"  placeholder="请输入副标题"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="curItem.type" class="type">
            <el-radio :label="1">医院</el-radio>
            <el-radio :label="2">社会组织</el-radio>
            <el-radio :label="3">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="链接" prop="linkUrl">
          <el-input v-model="curItem.linkUrl"  placeholder="请输入链接"></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="briefDesc">
          <el-input v-model="curItem.briefDesc" placeholder="请输入简单描述" :rows="6" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="curItem.remark" placeholder="请输入备注"
                    :autosize="{ minRows: 2, maxRows: 6}" type="textarea">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button size="small" type="primary" @click="saveCityItem()">保存</el-button>
        <el-button size="small" @click="editDialog.visible=false">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import commonjs from "@/api/common";
import Sortable from 'sortablejs';

export default {
  name: "itemList",
  data() {
    return {
      cityId: this.$route.query.id,//城市id
      itemList: [],
      sortedItemIdList: [],
      search: '',
      curItem: {
        id: null,
        cityId: null,
        status: null,
        type: null,
        sort: null,
        title: null,
        subTitle: null,
        linkUrl: null,
        briefDesc: null,
        remark: null,
      },
      rules: {
        type:  [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        title:  [
          { required: true, message: '请填写标题', trigger: 'blur' },
          { max: 255, message: '长度在 255 个字符之内', trigger: 'blur' }
        ],
        subTitle: [
          { max: 255, message: '长度在 255 个字符之内', trigger: 'blur' }
        ],
        linkUrl: [
          { max: 500, message: '长度在 500 个字符之内', trigger: 'blur' }
        ],
        briefDesc: [
          { max: 2000, message: '长度在 2000 个字符之内', trigger: 'blur' }
        ],
        remark: [
          { max: 255, message: '长度在 255 个字符之内', trigger: 'blur' }
        ],
      },
      editDialog: {
        visible: false,
        mode: 'add',
      },
    }
  },
  mounted() {
    this.getData();
    this.rowDrop();
  },
  methods: {
    getData() {
      let that = this;
      this.$ajax.get(commonjs.manager_api.city.item.list).then((res) => {
        if (res.data.status === "success") {
          that.itemList = res.data.list;
        }
      })
    },
    toEdit(obj) {
      if (obj.id) {
        this.editDialog.mode = 'edit';
        this.curItem = obj;
      } else {
        this.editDialog.mode = 'add';
        this.curItem = {
          id: null,
          cityId: null,
          status: null,
          type: null,
          sort: null,
          title: null,
          subTitle: null,
          linkUrl: null,
          briefDesc: null,
          remark: null,
        }
      }
      this.editDialog.visible = true;
    },
    del(id) {
      let that = this;
      this.$ajax.delete(commonjs.manager_api.city.item.delete.replace("{id}", id)).then((res) => {
        if (res.data.status === 'success') {
          that.$message.success("操作成功")
          that.getData();
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err)
        that.$message.error("操作失败")
      })
    },
    changeStatus(item) {
      let that = this;
      let status = (item.status + 1) % 2;
      this.$ajax.get(commonjs.manager_api.city.item.updateStatus.replace("{status}/{id}", status + "/" + item.id)).then(function (res) {
        if (res.data.status === 'success') {
          that.$message.success("操作成功")
          item.status = status;
        } else {
          that.$message.error(res.data.message)
        }
      }).catch((err) => {
        console.error(err)
        that.$message.error("操作失败")
      })
    },
    saveCityItem() {
      let that = this;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = commonjs.manager_api.city.item.save.replace("{cityId}", this.cityId);
          if (that.editDialog.mode === 'edit') {
            url = commonjs.manager_api.city.item.update.replace("{id}", this.curItem.id);
          }
          this.$ajax.post(url, this.curItem).then((res) => {
            if (res.data.status === 'success') {
              that.$message.success("操作成功");
              that.editDialog.visible = false;
              that.getData();
            } else {
              that.$message.error(res.data.message);
            }
          }).catch(err => {
            console.error(err);
            that.$message.error("操作失败");
          });
        } else {
          this.$message.error("请检查输入");
          return false;
        }
      });

    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        onEnd({newIndex, oldIndex}) {
          const currRow = _this.itemList.splice(oldIndex, 1)[0]
          _this.itemList.splice(newIndex, 0, currRow)
        }
      })
    },
    submitSort() {
      let that = this;
      $(this.itemList).each((index, obj) => {
        that.sortedItemIdList[index] = obj.id;
      });
      this.$ajax.post(commonjs.manager_api.city.item.updateSort.replace("{cityId}", this.cityId), this.sortedItemIdList).then(function (res) {
        if (res.data.status === 'success') {
          that.$message.success("排序成功");
        } else {
          that.$message.error(res.data.message);
        }
        that.getData();
      }).catch((err) => {
        console.error(err)
        that.$message.error("操作失败")
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

</style>
